import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State as UserSettingsState } from '../reducers/user-settings';
import { Brand } from '../../brand/models/brand';
import { ChartBrandingInfo } from '../../common/models/chart-branding-info';
import { FileHelperService } from '../../common/services/file-helper.service';
import { UserSettings } from '../models/user-settings';
import { MojoWellKnownNames } from '../../common/constants/mojo-well-known-names';

export const selectUserSettingsState = createFeatureSelector<UserSettingsState>('userSettings');

export const selectIsMyDashboardMode = createSelector([selectUserSettingsState], (userSettingsState: UserSettingsState) => userSettingsState && userSettingsState.userSettings && userSettingsState.userSettings.IsInMyDashboardMode);

export function getIsMyDashboardMode() {
  return selectIsMyDashboardMode;
}

export const t = createSelector([selectUserSettingsState], (s: UserSettingsState) => { return s.loaded });

export const getUserSettings = createSelector([selectUserSettingsState],
  (userSettingsState: UserSettingsState) => {
    return userSettingsState.userSettings;
  });

export const getPreviewMode = createSelector([selectUserSettingsState],
  (userSettingsState: UserSettingsState) => {
    if (userSettingsState.userSettings) {
      return userSettingsState.userSettings.IsInPreviewMode;
    } else {
      return false;
    }
  });

export const getCurrentBrandName = createSelector(
  [selectUserSettingsState],
  (userSettingsState: UserSettingsState) => {
    if (userSettingsState.userSettings) {
      return userSettingsState.userSettings.BrandName;
    } else {
      return '';
    }
  }
);

export const getCurrentProduct = createSelector(
  [selectUserSettingsState],
  (userSettingsState: UserSettingsState) => {
    if (userSettingsState.userSettings) {
      return userSettingsState.userSettings.Product;
    } else {
      return undefined;
    }
  }
);

export const getEffectiveProduct = createSelector(
  [getCurrentProduct, getPreviewMode],
  (currentProduct: string, isPreviewMode: boolean) => isPreviewMode ? MojoWellKnownNames.Products.Mci : currentProduct);

export const getCurrentBrand = createSelector(
  [getUserSettings],
  (userSettings: UserSettings) => {
    if (userSettings?.BrandName) {
      const brandName = (userSettings.IsInMyDashboardMode && !userSettings.IsInPreviewMode)
        ? 'mojo'
        : userSettings.BrandName;
      const fileHelperService = new FileHelperService();
      const chartJsonString = fileHelperService.loadTextFileAjaxSync(`./assets/brand/brands/${brandName}/ChartBranding.json`, 'application/json');

      return new Brand(brandName,
        `assets/brand/brands/${brandName}/${brandName}.css`,
        fileHelperService.loadJSON(chartJsonString) as ChartBrandingInfo);
    }
    return null;
  }
);
